import "../../styles/TermsAndConditions.css";

import React from "react";
import { useNavigate } from "react-router-dom";

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="terms-container">
      <div className="terms-header">
        <img
          src='/bm_icon.png'
          alt="Company Logo"
          className="terms-logo"
        />
        <h1>Terms and Conditions</h1>
        <button className="close-button" onClick={() => navigate(-1)}>
          &times;
        </button>
      </div>

      <div className="terms-content">
        <h2>Quick Commerce Delivery Terms of Service</h2>
        
        <h3>1. Service Nature</h3>
        <ol>
          <li>We are a delivery service only and not the manufacturer of any products.</li>
          <li>We pick products from partner stores/shops and deliver them to you.</li>
          <li>Original shop/manufacturer details are maintained with each product listing.</li>
        </ol>

        <h3>2. Health & Product Liability</h3>
        <ol>
          <li>We are not responsible for any health issues arising from consumed products.</li>
          <li>Product quality responsibility lies solely with the original shop/manufacturer.</li>
          <li>Allergy warnings (if any) must be checked with the original product packaging.</li>
        </ol>

        <h3>3. Order Modifications</h3>
        <ol>
          <li>No returns accepted for delivered products.</li>
          <li>No cancellations once order is placed and confirmed.</li>
          <li>In case of unavailable items, we may substitute with similar products or issue store credit.</li>
        </ol>

        <h3>4. Pricing & Payments</h3>
        <ol>
          <li>All service charges are included in the displayed product prices.</li>
          <li>Prices may fluctuate based on real-time shop pricing.</li>
          <li>We reserve the right to cancel orders with pricing errors.</li>
        </ol>

        <h3>5. Data Collection</h3>
        <ol>
          <li>We collect necessary data for order processing and delivery.</li>
          <li>Location data is used for delivery optimization.</li>
          <li>Contact information is used for delivery coordination.</li>
        </ol>

        <h3>6. Delivery Terms</h3>
        <ol>
          <li>You must be available to receive the order at provided address.</li>
          <li>Delivery attempts will be made twice before order is marked undeliverable.</li>
          <li>Perishable goods will not be left unattended.</li>
        </ol>

        <h3>7. Quick Commerce Specific</h3>
        <ol>
          <li>Delivery timelines are estimates only (typically 10-45 minutes).</li>
          <li>Inventory is updated in real-time but may sell out during ordering process.</li>
          <li>We may combine multiple shop orders into single delivery where applicable.</li>
          <li>Contactless delivery options available upon request.</li>
          <li>Temperature-controlled delivery for perishable items.</li>
        </ol>

        <h3>8. General</h3>
        <ol>
          <li>By using our service, you agree to these terms.</li>
          <li>We reserve the right to refuse service to anyone.</li>
          <li>Terms may be updated without prior notice.</li>
        </ol>

        <div className="last-updated">
          Last Updated: {new Date().toLocaleDateString()}
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;